module.exports = __webpack_public_path__ + "static/img/dell.080a4c0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/brands-that-trust-us/dell.png
// module id = fyr/
// module chunks = 1